import Vue from "vue";

// type-safe emitter using Vue
type Emitter = {
  $emit<K extends keyof Events>(event: K, payload: Events[K]): void;
  $on<K extends keyof Events>(
    event: K,
    callback: (payload: Events[K]) => void
  ): void;
};

export enum NotificationType {
  INFO = "info",
  ERROR = "error",
  WARNING = "warning",
}

export interface Notification {
  id?: number;
  title: string;
  message: string;
  type?: NotificationType;
}

// type that maps event names to their payload types
type Events = {
  notification: Notification;
  // Add other events and their payloads here
};

export const emitter: Emitter = new Vue() as Emitter;
